import styled from 'styled-components'

export const NotificationsMenuWrapper = styled.div`
  z-index: 105;
  position: fixed;
  inset: 0px 0px auto auto;
  margin: 0px;
  transform: translate(-80px, 65px);
`